import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get } from 'lodash';

import {
  BuildPriceCreativeConfigDefaultProps,
  BuildPriceCreativeConfigPropTypes,
} from 'client/data/models/native-ads-creative-config';
import {
  SiteServedAdDefaultProps,
  SiteServedAdPropTypes,
} from 'site-modules/shared/components/ad-unit/ad-unit-prop-types';
import { BUILD_PRICE_AD } from 'site-modules/shared/components/native-ad/utils/constants';
import { withSiteServedAdWrapper } from 'site-modules/shared/components/native-ad/site-served-ad-wrapper/site-served-ad-wrapper';
import { definePlatform } from 'site-modules/shared/components/native-ad/utils/utils';
import { AdLabel } from 'site-modules/shared/components/native-ad/native-ad-components/ad-label/ad-label';
import { CtaButtonText } from 'site-modules/shared/components/native-ad/native-ad-components/cta-button-text/cta-button-text';
import { DfpTracking } from 'site-modules/shared/components/native-ad/utils/dfp-tracking';
import { siteServedAdTrackingWrapper } from 'site-modules/shared/components/native-ad/site-served-ad-tracking-wrapper/site-served-ad-tracking-wrapper';

import './build-price-button-ad.scss';

export function BuildPriceButtonAdUI({
  adRef,
  adClickTrackingListener,
  adLoadTrackingListener,
  adTrackers,
  position,
  creativeConfig,
  mobile,
  wrapperClass,
  linkUrlClass,
  ivtClassName,
}) {
  const cta = get(creativeConfig, 'creativeConfigData.cta');

  const loadTrackingListener = useCallback(
    event => {
      adLoadTrackingListener(event, cta);
    },
    [adLoadTrackingListener, cta]
  );

  if (!cta) return null;

  const {
    siteServedAdsUpdater,
    creativeConfigData: { lineItemId, linkDisplayUrl, siteServedCreativeId, target },
    traffickingData: { clickTracker },
  } = creativeConfig;

  const ctaURL = clickTracker[definePlatform(mobile)];
  const ctaTarget = target || '_blank';

  const nativeStyle = BUILD_PRICE_AD.NATIVE_STYLE;

  return (
    <div
      className={classnames('build-price-button-ad d-flex flex-column align-items-center', wrapperClass, ivtClassName)}
      data-tracking-parent={nativeStyle}
      data-viewability={`${nativeStyle}-${position}`}
      ref={adRef}
    >
      <div className="pos-r">
        <a
          className="btn size-16 btn-sm bg-white btn-outline-blue-50 py-0_75 px-2"
          href={ctaURL}
          rel="noopener noreferrer"
          target={ctaTarget}
          onClick={adClickTrackingListener}
        >
          <CtaButtonText text={cta} />
        </a>
        <AdLabel styles={{ top: '50%' }} />
      </div>
      <span className={classnames('xsmall text-decoration-none mt-0_25', linkUrlClass)}>{linkDisplayUrl}</span>
      <DfpTracking
        lineItemId={lineItemId}
        siteServedCreativeId={siteServedCreativeId}
        mobile={mobile}
        nativeStyle={nativeStyle}
        position={position}
        slotRenderEndListener={loadTrackingListener}
        siteServedAdsUpdater={siteServedAdsUpdater}
      />
      {adTrackers}
    </div>
  );
}

BuildPriceButtonAdUI.propTypes = {
  ...SiteServedAdPropTypes,
  creativeConfig: BuildPriceCreativeConfigPropTypes,
  wrapperClass: PropTypes.string,
  linkUrlClass: PropTypes.string,
};

BuildPriceButtonAdUI.defaultProps = {
  ...SiteServedAdDefaultProps,
  creativeConfig: BuildPriceCreativeConfigDefaultProps,
  wrapperClass: null,
  linkUrlClass: 'text-blue-50',
};

const BuildPriceButtonAdWrapper = withSiteServedAdWrapper(siteServedAdTrackingWrapper(BuildPriceButtonAdUI));

export function BuildPriceButtonAd(props) {
  return <BuildPriceButtonAdWrapper {...props} adType={BUILD_PRICE_AD} />;
}
